import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail, ArrowRight, CheckCircle } from 'lucide-react';
import { useAuth } from '../hooks/useAuth';

export function EmailVerificationReminderPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleContinue = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-lg">
        <div className="bg-white py-8 px-4 shadow-lg sm:rounded-lg sm:px-10">
          {/* Icon and Header */}
          <div className="text-center mb-6">
            <div className="mx-auto flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 mb-4">
              <Mail className="w-8 h-8 text-blue-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900">
              Καλώς ήρθατε στο Pathiety!
            </h2>
            <p className="mt-2 text-sm text-gray-600">
              Χαίρομαι που γίνατε μέλος της κοινότητάς μας
            </p>
          </div>

          {/* User Info */}
          {user && (
            <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
              <div className="flex items-center">
                <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                <div>
                  <p className="text-sm font-medium text-green-800">
                    Εγγραφή ολοκληρώθηκε επιτυχώς!
                  </p>
                  <p className="text-sm text-green-700">
                    {user.firstName} {user.lastName}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Main Message */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 mb-6">
            <div className="text-center">
              <div className="text-amber-800 text-base font-medium mb-2">
                📧 Επιβεβαίωση Email
              </div>
              <p className="text-amber-700 text-sm leading-relaxed">
                Για να μπορέσετε να ανεβάσετε νέα περιστατικά, να ψηφίσετε σε υπάρχοντα περιστατικά, 
                να δημοσιεύσετε στο φόρουμ ή να δείτε το αρχείο, πρέπει να επιβεβαιώσετε το email σας.
              </p>
            </div>
          </div>

          {/* Email Sent Notice */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="text-center">
              <p className="text-blue-800 text-sm">
                Ένα email επιβεβαίωσης έχει σταλεί στη διεύθυνση:
              </p>
              <p className="text-blue-900 font-medium text-sm mt-1">
                {user?.email}
              </p>
              <p className="text-blue-700 text-xs mt-2">
                Ελέγξτε τα εισερχόμενά σας και ακολουθήστε τις οδηγίες
              </p>
            </div>
          </div>

          {/* Continue Button */}
          <div className="mt-6">
            <button
              onClick={handleContinue}
              className="w-full flex justify-center items-center py-3 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              Συνεχίστε στο Pathiety
              <ArrowRight className="w-4 h-4 ml-2" />
            </button>
          </div>

          {/* Help Text */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              Μπορείτε να περιηγηθείτε στην πλατφόρμα, αλλά θα χρειαστείτε επιβεβαίωση email για πλήρη πρόσβαση.
            </p>
          </div>

          {/* Resend Link */}
          <div className="mt-4 text-center">
            <button
              onClick={() => {
                // TODO: Implement resend verification email
                console.log('Resend verification email');
              }}
              className="text-blue-600 hover:text-blue-500 text-sm font-medium"
            >
              Δεν λάβατε email; Στείλετε ξανά
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}